(function () {
  if (window.uxGalleryInit) return;
  window.uxGalleryInit = true;

  const THRESHOLD = 40;
  const MOBILE = () => window.matchMedia('(max-width: 749px)').matches;

  const orderedSlides = (gallery) => {
    const list = gallery.querySelector('.product__media-list');
    if (!list) return [];
    return Array.from(list.querySelectorAll('.product__media-item')).filter(
      (slide) => !slide.classList.contains('hide')
    );
  };

  const currentIndex = (slides) => {
    const i = slides.findIndex((slide) => slide.classList.contains('is-active'));
    return i < 0 ? 0 : i;
  };

  const thumbButtonFor = (gallery, mediaId) => {
    const item = gallery.querySelector('.thumbnail-list__item[data-target="' + mediaId + '"]');
    return item ? item.querySelector('button') : null;
  };

  const syncActiveThumb = (gallery) => {
    const list = gallery.querySelector('.product__media-list');
    if (!list) return;
    const slides = Array.from(list.querySelectorAll('.product__media-item[data-media-id]')).filter(
      (slide) => !slide.classList.contains('hide')
    );
    if (slides.length < 2) return;

    const listRect = list.getBoundingClientRect();
    const centerX = listRect.left + listRect.width / 2;
    let best = null;
    let bestDist = Infinity;
    slides.forEach((slide) => {
      const rect = slide.getBoundingClientRect();
      const dist = Math.abs(rect.left + rect.width / 2 - centerX);
      if (dist < bestDist) {
        bestDist = dist;
        best = slide;
      }
    });
    if (!best) return;

    const mediaId = best.dataset.mediaId;
    const activeThumb = gallery.querySelector('.thumbnail-list__item[data-target="' + mediaId + '"]');
    if (!activeThumb) return;
    const btn = activeThumb.querySelector('button');
    if (!btn || btn.getAttribute('aria-current') === 'true') return;

    gallery
      .querySelectorAll('.thumbnail-list__item button[aria-current]')
      .forEach((b) => b.removeAttribute('aria-current'));
    btn.setAttribute('aria-current', 'true');

    const thumbsSlider = gallery.querySelector('[id^="Slider-Thumbnails"]');
    if (thumbsSlider) {
      const tRect = activeThumb.getBoundingClientRect();
      const sRect = thumbsSlider.getBoundingClientRect();
      if (tRect.left < sRect.left || tRect.right > sRect.right) {
        thumbsSlider.scrollTo({ left: activeThumb.offsetLeft, behavior: 'smooth' });
      }
    }
  };

  const initActiveSync = (gallery) => {
    if (gallery.dataset.uxSyncReady) return;
    gallery.dataset.uxSyncReady = 'true';
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const list = gallery.querySelector('.product__media-list');
    if (viewer) viewer.addEventListener('slideChanged', () => syncActiveThumb(gallery));
    if (list) list.addEventListener('scrollend', () => syncActiveThumb(gallery));
  };

  const navigate = (gallery, dir) => {
    const slides = orderedSlides(gallery);
    if (slides.length < 2) return false;

    const current = currentIndex(slides);
    const count = slides.length;
    const target = ((current + dir) % count + count) % count;
    if (target === current) return false;

    const mediaId = slides[target].dataset.mediaId;
    const button = thumbButtonFor(gallery, mediaId);
    if (button) {
      button.click();
    } else {
      slides[target].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    const activeThumb = gallery.querySelector('.thumbnail-list__item[data-target="' + mediaId + '"]');
    if (activeThumb) activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    return true;
  };

  const suppressNextClick = (viewer) => {
    const handler = (event) => {
      event.stopPropagation();
      event.preventDefault();
      viewer.removeEventListener('click', handler, true);
    };
    viewer.addEventListener('click', handler, true);
    setTimeout(() => viewer.removeEventListener('click', handler, true), 400);
  };

  const initDrag = (gallery) => {
    if (gallery.dataset.uxDragReady) return;
    gallery.dataset.uxDragReady = 'true';

    const viewer = gallery.querySelector('.product__media-list');
    if (!viewer) return;

    let startX = 0;
    let startY = 0;
    let dragging = false;
    let captured = false;
    let pointerId = null;

    viewer.addEventListener('pointerdown', (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      if (event.button != null && event.button !== 0) return;
      dragging = true;
      captured = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
    });

    viewer.addEventListener('pointermove', (event) => {
      if (!dragging || event.pointerId !== pointerId || captured) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
        captured = true;
        try { viewer.setPointerCapture(pointerId); } catch (e) {}
      }
    });

    const finish = (event) => {
      if (!dragging || event.pointerId !== pointerId) return;
      dragging = false;
      if (captured) {
        try { viewer.releasePointerCapture(pointerId); } catch (e) {}
      }

      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) < THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return;

      const didNavigate = navigate(gallery, dx < 0 ? 1 : -1);
      if (didNavigate) suppressNextClick(viewer);
    };

    viewer.addEventListener('pointerup', finish);
    viewer.addEventListener('pointercancel', finish);
  };

  const cloneSlide = (slide) => {
    const rect = slide.getBoundingClientRect();
    const img = slide.querySelector('img');
    const clone = document.createElement('div');
    clone.className = 'ux-g-clone';
    clone.setAttribute('aria-hidden', 'true');
    clone.style.cssText = 'flex:0 0 ' + rect.width + 'px;width:' + rect.width + 'px;height:' + rect.height + 'px;';
    if (img) {
      const ci = document.createElement('img');
      ci.src = img.currentSrc || img.src;
      ci.alt = '';
      clone.appendChild(ci);
    }
    return clone;
  };

  const setupMobileLoop = (gallery) => {
    if (!MOBILE()) return;
    const list = gallery.querySelector('.product__media-list');
    if (!list || list.dataset.uxLoop) return;

    const slides = orderedSlides(gallery);
    if (slides.length < 2) return;
    list.dataset.uxLoop = 'true';

    const first = slides[0];
    const last = slides[slides.length - 1];

    const lastClone = cloneSlide(last);
    const firstClone = cloneSlide(first);
    list.insertBefore(lastClone, first);
    list.appendChild(firstClone);

    const jumpTo = (el) => {
      const prev = list.style.scrollBehavior;
      list.style.scrollBehavior = 'auto';
      list.scrollLeft = el.offsetLeft;
      list.style.scrollBehavior = prev || '';
    };

    requestAnimationFrame(() => jumpTo(first));

    const step = first.offsetLeft - lastClone.offsetLeft;
    let timer;
    list.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const x = list.scrollLeft;
        if (Math.abs(x - lastClone.offsetLeft) < step * 0.5) {
          jumpTo(last);
        } else if (Math.abs(x - firstClone.offsetLeft) < step * 0.5) {
          jumpTo(first);
        }
      }, 90);
    }, { passive: true });
  };

  const initGallery = (gallery) => {
    initDrag(gallery);
    setupMobileLoop(gallery);
    initActiveSync(gallery);
  };

  const initAll = () => {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 200);
  });
})();
